module.exports = __webpack_public_path__ + "static/media/team_1.81b1b7eb.jpeg";